import { render, staticRenderFns } from "./StandardReportRegistry.vue?vue&type=template&id=53ae8d9d&scoped=true"
import script from "./StandardReportRegistry.vue?vue&type=script&lang=js"
export * from "./StandardReportRegistry.vue?vue&type=script&lang=js"
import style0 from "./StandardReportRegistry.vue?vue&type=style&index=0&id=53ae8d9d&prod&scoped=true&lang=scss"
import style1 from "./StandardReportRegistry.vue?vue&type=style&index=1&id=53ae8d9d&prod&lang=css"
import style2 from "./StandardReportRegistry.vue?vue&type=style&index=2&id=53ae8d9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ae8d9d",
  null
  
)

export default component.exports